import { render } from "./formgroupswitcheslist.vue?vue&type=template&id=793d7d26"
import script from "./formgroupswitcheslist.vue?vue&type=script&lang=js"
export * from "./formgroupswitcheslist.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__